import { CompositeNavigationProp, RouteProp } from "@react-navigation/native";
import React, { useCallback, useContext } from "react";
import { UserLoggedInNavigatorNavigationProp } from "../../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import { StorecastShowFileParamList } from "./StorecastShowFileNavigator";
import {
  StoreFilesScreenComponent,
  onPressIntegrationFileType,
} from "../FilesScreenComponent";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { StorecastShowFileContext } from "./StorecastShowFileContext";

type Props = {
  navigation: CompositeNavigationProp<
    UserLoggedInNavigatorNavigationProp<"Dashboard">,
    NativeStackNavigationProp<
      StorecastShowFileParamList,
      "StorecastShowFileScreen"
    >
  >;
  route: RouteProp<StorecastShowFileParamList, "StorecastShowFileScreen">;
};

export function StorecastShowFileScreen(props: Props) {
  const { openFile } = useContext(StorecastShowFileContext);
  const onShowAllFiles = useCallback(() => {
    props.navigation.navigateDeprecated("StorecastShowFileAllFiles", {});
  }, [props.navigation]);
  const onPressIntegrationFile: onPressIntegrationFileType = useCallback(
    ({ id, title }) => {
      props.navigation.navigateDeprecated("EmaginWebview", {
        eMaginId: id,
        title,
      });
    },
    [props.navigation]
  );

  return (
    <StoreFilesScreenComponent
      includeIntegrationFiles={false}
      modal
      onPressFile={openFile}
      onShowAllFiles={onShowAllFiles}
      onPressIntegrationFile={onPressIntegrationFile}
    />
  );
}
